import { useEffect, useState } from "react";
import { Toaster } from "sonner";
import { api, getToken, clearToken } from "./api";
import Login from "./Login";
import ClientDashboard from "./ClientDashboard";
import AdminDashboard from "./AdminDashboard";

export default function CommunityApp() {
  const [user, setUser] = useState(null);
  const [checking, setChecking] = useState(true);

  const loadMe = () => api.get("/auth/me").then((r) => setUser(r.data)).catch(() => { clearToken(); setUser(null); }).finally(() => setChecking(false));

  useEffect(() => {
    if (!getToken()) { setChecking(false); return; }
    loadMe();
    // eslint-disable-next-line
  }, []);

  const logout = () => { clearToken(); setUser(null); };

  return (
    <>
      <Toaster position="top-center" richColors />
      {checking ? (
        <div className="flex min-h-screen items-center justify-center bg-[var(--cream)] text-[var(--ink-soft)]">Loading…</div>
      ) : !user ? (
        <Login onLogin={setUser} />
      ) : user.role === "admin" ? (
        <AdminDashboard user={user} onLogout={logout} />
      ) : (
        <ClientDashboard user={user} onLogout={logout} refreshUser={loadMe} />
      )}
    </>
  );
}
